import { BreadcrumbActionMenuButton } from '@components/breadcrumbs';
import { Group } from '@components/layout';
import { useModal } from '@components/modal';
import { Typography } from '@components/typography';
import { Workspace } from '@generated/graphql';
import { Menu, MenuItem } from '@mui/material';
import {
  WorkspacesMoreDropdownChangeThumbnailModal,
  WorkspacesMoreDropdownDeleteModal,
  WorkspacesMoreDropdownEditModal,
} from '@subsets/workspaces';
import { MouseEvent, useState } from 'react';
import { WorkspaceResourcesModal } from './resources/WorkspaceResourcesModal';

type WorkspacesMoreButtonDropdownProps = {
  workspace?: Omit<Workspace, 'organization'>;
  isLandingPageWorkspace: boolean;
};

export const WorkspacesMoreDropdown = ({
  workspace,
  isLandingPageWorkspace,
}: WorkspacesMoreButtonDropdownProps) => {
  const { name, workspaceId, organizationId, description, tags } = workspace || {};
  const workspaceData = {
    workspaceName: name,
    description,
    tags,
    workspaceId,
    isLandingPageWorkspace,
  };

  const { showModal: showWorkspaceResourcesModal } = useModal({
    component: WorkspaceResourcesModal,
    componentProps: { organizationId, workspaceId },
    modalProps: { title: `${name} resources`, sx: { maxWidth: '875px', width: '90%' } },
  });

  const { showModal: showEditWorkspaceModal } = useModal({
    component: WorkspacesMoreDropdownEditModal,
    componentProps: { ...workspaceData },
    modalProps: { title: 'Edit workspace' },
  });

  const { showModal: showChangeThumbnailModal } = useModal({
    component: WorkspacesMoreDropdownChangeThumbnailModal,
    componentProps: { ...workspaceData },
    modalProps: { title: 'Change thumbnail', sx: { maxWidth: '875px', width: '90%' } },
  });

  const { showModal: showDeleteWorkspaceModal } = useModal({
    component: WorkspacesMoreDropdownDeleteModal,
    componentProps: { ...workspaceData },
    modalProps: { title: `Delete ${name}` },
  });
  const [anchorEl, setAnchorEl] = useState<Element>(null);
  const open = Boolean(anchorEl);

  const handleMenuClose = () => setAnchorEl(null);
  const handleMenuClick = (event: MouseEvent) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDeleteOpen = () => {
    showDeleteWorkspaceModal();
    handleMenuClose();
  };

  const handleChannelsOpen = () => {
    showWorkspaceResourcesModal();
    handleMenuClose();
  };
  const handleChangeThumbnail = () => {
    showChangeThumbnailModal();
    handleMenuClose();
  };

  const handleRenameOpen = () => {
    showEditWorkspaceModal();
    handleMenuClose();
  };

  return (
    <Group alignItems="center">
      <BreadcrumbActionMenuButton onClick={handleMenuClick} />
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleMenuClose}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{ paper: { sx: { mt: 3 } } }}
      >
        <MenuItem onClick={handleRenameOpen}>
          <Typography>Edit</Typography>
        </MenuItem>
        <MenuItem onClick={handleChannelsOpen}>
          <Typography>Resources</Typography>
        </MenuItem>
        <MenuItem onClick={handleChangeThumbnail}>
          <Typography>Thumbnail</Typography>
        </MenuItem>
        <MenuItem onClick={handleDeleteOpen}>
          <Typography>Delete</Typography>
        </MenuItem>
      </Menu>
    </Group>
  );
};
